import { Dialog, DialogContent } from '@mui/material';

import DialogCloseButton from '@components/DialogCloseButton';
import CommentsView from '@components/experiments/comments/CommentsView';
import PlutoErrorBoundary from '@components/PlutoErrorBoundary';

import Plot from '@models/Plot';

type Props = {
    onClose: () => void;
    open: boolean;
    plot: Plot;
};

const CommentsModal = ({ onClose, open, plot }: Props) => (
    <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        PaperProps={{
            style: { height: '100%' },
        }}
    >
        <DialogCloseButton onClose={onClose} />
        <DialogContent>
            <PlutoErrorBoundary>
                <CommentsView objectUuid={plot.uuid} />
            </PlutoErrorBoundary>
        </DialogContent>
    </Dialog>
);

export default CommentsModal;
